var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 0H13.97L16.5275 2.54523C10.3263 5.17169 11.11 13.8228 11.11 13.8228C16.4175 4.224 19.7587 5.97046 19.7587 5.97046L22 8.59692V0ZM19.25 12.1846V14.8923H2.75V4.06154H9.625V1.35385H0V2.70769V4.06154V14.8923V17.6H19.25H22V14.8923V12.1846H19.25Z",
    fill: "#F6B119"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtract);
export default __webpack_public_path__ + "static/media/extract.e9cea9ffdc22945f836d7bae8107782c.svg";
export { ForwardRef as ReactComponent };